import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight, ShoppingCart } from 'lucide-react';
import { useAppSelector } from '@/app/hooks';
import { CountBubble } from '@/components/ui';
import { formatCurrency } from '@/utils/formatters';

/** O4 — phone only. Floats above the tab bar on the catalog; opens /cart. */
export const FloatingCartBar: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { items, calculation, isCalculating, orderType } = useAppSelector((s) => s.cart);
    const count = items.reduce((n, i) => n + i.quantity, 0);
    if (items.length === 0) return null;

    return (
        <div className="fixed inset-x-3.5 bottom-[92px] z-30 flex h-[66px] items-center gap-3 rounded-pill bg-surface-brand pl-2.5 pr-2 shadow-brand lg:hidden">
            <span className="relative flex h-[46px] w-[46px] shrink-0 items-center justify-center rounded-full bg-white/[.14] text-white">
                <ShoppingCart className="h-[21px] w-[21px]" />
                <CountBubble count={count} tone="accent" className="absolute -top-[3px] -right-[3px] !h-5 !min-w-[20px] !text-[11px] !shadow-none" />
            </span>
            <span className="flex min-w-0 flex-1 flex-col">
                <span className="text-[19px] font-black leading-tight text-white tnum">
                    {calculation && !isCalculating ? formatCurrency(calculation.grandTotal) : calculation ? formatCurrency(calculation.grandTotal) : '—'}
                </span>
                <span className="truncate text-xs font-semibold text-primary-100">
                    {t('cart.itemsCount', { count })} · {t(`cart.orderTypesShort.${orderType}` as 'cart.orderTypesShort.DINE_IN')}
                </span>
            </span>
            <button type="button" onClick={() => navigate('/cart')} className="flex h-[50px] items-center gap-1.5 rounded-pill bg-accent-500 px-5 text-base font-black text-ink-onAccent active:scale-[.97]">
                {t('cart.proceedToCheckout')}
                <ArrowRight className="h-[18px] w-[18px]" />
            </button>
        </div>
    );
};
export default FloatingCartBar;
